export function resize() {
	// Tolerance (px) is the size a viewport can chance
	// before updating css variables this prevents jerky
	// resizing when browser chrome disappears on mobile
	const tolerance = 60;
	let lastHeight = window.innerHeight;
	let lastWidth = window.innerWidth;

	const resizeVars = () => {
		let offsetHeaderHeight = 0;

		if (Math.abs(lastHeight - window.innerHeight) > tolerance) {
			vh = window.innerHeight * 0.01;
			vh = vh.toFixed(1);
			document.documentElement.style.setProperty('--vh', `${ vh }px`);
			lastHeight = window.innerHeight;
		}

		if (lastWidth !== window.innerWidth) {
			vw = window.innerWidth * 0.01;
			vw = vw.toFixed(1);
			document.documentElement.style.setProperty('--vw', `${ vw }px`);
			lastWidth = window.innerWidth;
		}

		if (document.querySelector('.secondary-nav')) {
			const secondaryNavHeight = document.querySelector('.secondary-nav');
			

			if (secondaryNavHeight) {
				offsetSecondaryNavHeight = secondaryNavHeight.offsetHeight;
			} else {
				offsetSecondaryNavHeight = 100;
			}
			document.documentElement.style.setProperty('--secondary-nav-height', `${ offsetSecondaryNavHeight }px`);
		}

		if (document.querySelector('.site-header')) {
			const headerHeight = document.querySelector('.site-header');
			

			if (headerHeight) {
				offsetHeaderHeight = headerHeight.offsetHeight;
			} else {
				offsetHeaderHeight = 100;
			}
			document.documentElement.style.setProperty('--header-height', `${ offsetHeaderHeight }px`);
		}
		document.querySelectorAll(".sub-menu").forEach(_sub => {
			let subNavHeight = _sub.scrollHeight;
			_sub.style.setProperty('--sub-nav-height', `${ subNavHeight }px`);
		});
		document.querySelectorAll(".site-read-more-section").forEach(_rm => {
			const getCollapsedHeight = _rm.style.getPropertyValue('--collapsed');

			if (getCollapsedHeight && (_rm.querySelector(".site-read-more-section__inner").scrollHeight > (parseInt(getCollapsedHeight,10)+ 40))) {
				_rm.classList.add("site-read-more-section--enabled");
			} else {
				_rm.classList.remove("site-read-more-section--enabled");
			}
			
		});

		if (document.querySelector(".single-shows") &&
			document.querySelector(".site-page__events-right-sticky") && 
			document.querySelector("#event-key-info")) {
				document.querySelector(".site-page__events-right-sticky").style.setProperty("--top-offset", (document.querySelector("#event-key-info").scrollHeight - offsetHeaderHeight + 2));
				document.querySelector(".site-page__events-right-sticky").style.setProperty("--top-offset-desktop", (offsetHeaderHeight + 30));
			}
	};
	window.addEventListener('resize', () => {
		resizeVars();
	});
	setTimeout(function() {
		resizeVars();
	}, 100);
	resizeVars();
}

